import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AuthService } from '../auth';

export const authGuard: CanActivateFn = (snapshot: ActivatedRouteSnapshot) => {
    const auth = inject(AuthService);
    if (auth.isLoggedIn()) {
        return true;
    } else {
        auth.signOut();
        return false;
    }
};
